import requestTransferPoint from '@/api/transferPoint';

const state = {
  connectedList: {},
};

const getters = {
  connectedList: (state) => state.connectedList,
};

const actions = {
  async getConnectedList({ commit, dispatch }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestTransferPoint();
    commit('setConnectedList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setConnectedList(state, connectedList) {
    state.connectedList = connectedList;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
